import { rememberLastEnvironment } from '@lib/last-team'
import { ENVIRONMENT_KINDS, type EnvironmentKind } from '@lib/use-app-route'

export const ENVIRONMENT_LABELS: Record<EnvironmentKind, string> = { production: 'Production', sandbox: 'Sandbox' }

export const environmentDotClass: Record<EnvironmentKind, string> = {
  production: 'bg-o-mint',
  sandbox: 'bg-o-amber'
}

export const environmentPath = (pathname: string, teamSlug: string, kind: EnvironmentKind) => {
  const parts = pathname.split('/').filter(Boolean)
  const isEnvRoute = parts.length >= 2 && ENVIRONMENT_KINDS.includes(parts[1] as EnvironmentKind)
  const section = isEnvRoute ? parts[2] : undefined
  return `/${teamSlug}/${kind}${section ? `/${section}` : ''}`
}

type Navigator = { push: (href: string) => void }

export const switchEnvironment = (router: Navigator, pathname: string, teamSlug: string | undefined, kind: EnvironmentKind) => {
  if (!teamSlug) return
  rememberLastEnvironment(kind)
  router.push(environmentPath(pathname, teamSlug, kind))
}
